import React, { useContext, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../css/Commission.css";
import "../../css/Notification.css";
import SidebarContext from "../sidebarcontext/SidebarContext";
import TodayTab from "./TodayTab";
import StudentTab from "./StudentTab";
import TeacherTab from "./TeacherTab";
import AdminTab from "./AdminTab";
import StaffTab from "./StaffTab";
import NotLoggedinTab from "./NotLoggedinTab";
import SummaryTab from "./SummaryTab";
import AcademicHeader from "../AcademicHeader";

export default function AppUsage() {
  const { todayDate, AcademicYear } = useContext(SidebarContext);

  const [activeTab, setActiveTab] = useState({
    tab1: true,
    tab2: false,
    tab3: false,
    tab4: false,
    tab5: false,
    tab6: false,
    tab7: false,
  });
  const handleTab1 = () => {
    setActiveTab({
      tab1: true,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
      tab6: false,
      tab7: false,
    });
  };
  const handleTab2 = () => {
    setActiveTab({
      tab1: false,
      tab2: true,
      tab3: false,
      tab4: false,
      tab5: false,
      tab6: false,
      tab7: false,
    });
  };
  const handleTab3 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: true,
      tab4: false,
      tab5: false,
      tab6: false,
      tab7: false,
    });
  };
  const handleTab4 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: true,
      tab5: false,
      tab6: false,
      tab7: false,
    });
  };
  const handleTab5 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: true,
      tab6: false,
      tab7: false,
    });
  };
  const handleTab6 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
      tab6: true,
      tab7: false,
    });
  };
  const handleTab7 = () => {
    setActiveTab({
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false,
      tab5: false,
      tab6: false,
      tab7: true,
    });
  };
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />

      <div className="col-lg-12 col-md-12 col-sm-12 contentMainSection">
        <div className="row">
          <div className="page-header">
            <div className="text-start  page-title">App Usage</div>
            <div className="page-date">
              <div className="sec-content">
                <AcademicHeader
                  todayDate={todayDate}
                  AcademicYear={AcademicYear}
                />
                {/* <span>|</span> Fiscal Year :{" "}
                                {fiscalYear.StartDate}
                                <span>-</span>
                                {fiscalYear.EndDate} */}
              </div>
            </div>
          </div>
        </div>
        <hr />

        <div className="tabview ">
          <div className="insidePopup--div">
            <ul>
              <li
                className={activeTab.tab1 === true ? "active" : ""}
                onClick={handleTab1}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Today{" "}
              </li>
              <li
                className={activeTab.tab2 === true ? "active" : ""}
                onClick={handleTab2}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Student{" "}
              </li>
              <li
                className={activeTab.tab3 === true ? "active" : ""}
                onClick={handleTab3}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Teacher{" "}
              </li>
              <li
                className={activeTab.tab4 === true ? "active" : ""}
                onClick={handleTab4}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Admin{" "}
              </li>
              <li
                className={activeTab.tab5 === true ? "active" : ""}
                onClick={handleTab5}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Staff{" "}
              </li>
              <li
                className={activeTab.tab6 === true ? "active" : ""}
                onClick={handleTab6}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Not Loggined{" "}
              </li>
              <li
                className={activeTab.tab7 === true ? "active" : ""}
                onClick={handleTab7}
              >
                <i className="fa fa-file-text-o mr-1 icon"></i>Summary{" "}
              </li>
            </ul>
          </div>
        </div>

        <div className="content-section main-content">
          {activeTab.tab1 && <TodayTab />}
          {activeTab.tab2 && <StudentTab />}
          {activeTab.tab3 && <TeacherTab />}
          {activeTab.tab4 && <AdminTab />}
          {activeTab.tab5 && <StaffTab />}
          {activeTab.tab6 && <NotLoggedinTab />}
          {activeTab.tab7 && <SummaryTab />}
        </div>
      </div>
    </>
  );
}
